import cn from 'classnames';
import * as React from 'react';
import styles from './BrandLogo.module.scss';

interface IProps {
  className?: string;
  alt?: string;
  image: string;
  onError?: React.ReactEventHandler<HTMLImageElement>;
}

const BrandLogo = ({ alt = '', className, image, onError }: IProps) => {
  return <img src={image} alt={alt} onError={onError} className={cn(styles.logo, className)} />;
};

export default BrandLogo;
